import * as React from 'react';

const Furniture = () => (
  <svg
    width={111}
    height={93}
    viewBox="0 0 111 93"
    fillRule="evenodd"
    stroke="#1C1F34"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path
      stroke="none"
      strokeWidth={1}
      fill="#8EAFFF"
      d="M13.629,47.868 L65.876,47.868 L13.629,47.868 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#8EAFFF"
      d="M13.629,47.868 L65.876,47.868 L13.629,47.868 Z"
    />
    <path strokeWidth={3} d="M8,91.5 L104,91.5" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#E7EBF6"
      d="M15.981,1.5 L78.989,1.5 C83.755,1.5 87.619,5.364 87.619,10.131 L87.619,82.393 C87.619,87.16 83.755,91.024 78.989,91.024 L15.981,91.024 C11.214,91.024 7.35,87.16 7.35,82.393 L7.35,10.131 C7.35,5.364 11.214,1.5 15.981,1.5 Z"
    />
    <path
      stroke="#3A427C"
      strokeWidth={3}
      d="M15.981,1.5 L78.989,1.5 C83.755,1.5 87.619,5.364 87.619,10.131 L87.619,82.393 C87.619,87.16 83.755,91.024 78.989,91.024 L15.981,91.024 C11.214,91.024 7.35,87.16 7.35,82.393 L7.35,10.131 C7.35,5.364 11.214,1.5 15.981,1.5 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M84.406,81.835 L84.406,10.69 C84.406,7.389 81.731,4.713 78.43,4.713 L16.538,4.713 C13.239,4.713 10.563,7.389 10.563,10.69 L10.563,81.835 C10.563,85.136 13.239,87.812 16.538,87.812 L78.43,87.812 C81.731,87.812 84.406,85.136 84.406,81.835"
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#505FB4"
      points="1.5 21.705 7.35 21.705 7.35 13.064 1.5 13.064"
    />
    <polygon strokeWidth={3} points="1.5 21.705 7.35 21.705 7.35 13.064 1.5 13.064" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.42,19.599 L23.07,18.249" />
    <path strokeWidth={1.5} d="M24.42,19.599 L23.07,18.249" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.42,19.877 L23.07,21.227" />
    <path strokeWidth={1.5} d="M24.42,19.877 L23.07,21.227" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.697,19.877 L26.047,21.227" />
    <path strokeWidth={1.5} d="M24.697,19.877 L26.047,21.227" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.697,19.599 L26.047,18.249" />
    <path strokeWidth={1.5} d="M24.697,19.599 L26.047,18.249" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.346,19.599 L45.996,18.249" />
    <path strokeWidth={1.5} d="M47.346,19.599 L45.996,18.249" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.346,19.877 L45.996,21.227" />
    <path strokeWidth={1.5} d="M47.346,19.877 L45.996,21.227" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.623,19.877 L48.973,21.227" />
    <path strokeWidth={1.5} d="M47.623,19.877 L48.973,21.227" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.623,19.599 L48.973,18.249" />
    <path strokeWidth={1.5} d="M47.623,19.599 L48.973,18.249" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.271,19.599 L68.921,18.249" />
    <path strokeWidth={1.5} d="M70.271,19.599 L68.921,18.249" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.271,19.877 L68.921,21.227" />
    <path strokeWidth={1.5} d="M70.271,19.877 L68.921,21.227" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.549,19.877 L71.899,21.227" />
    <path strokeWidth={1.5} d="M70.549,19.877 L71.899,21.227" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.549,19.599 L71.899,18.249" />
    <path strokeWidth={1.5} d="M70.549,19.599 L71.899,18.249" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.42,46.123 L23.07,44.773" />
    <path strokeWidth={1.5} d="M24.42,46.123 L23.07,44.773" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.42,46.401 L23.07,47.751" />
    <path strokeWidth={1.5} d="M24.42,46.401 L23.07,47.751" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.697,46.401 L26.047,47.751" />
    <path strokeWidth={1.5} d="M24.697,46.401 L26.047,47.751" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.697,46.123 L26.047,44.773" />
    <path strokeWidth={1.5} d="M24.697,46.123 L26.047,44.773" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.346,46.123 L45.996,44.773" />
    <path strokeWidth={1.5} d="M47.346,46.123 L45.996,44.773" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.346,46.401 L45.996,47.751" />
    <path strokeWidth={1.5} d="M47.346,46.401 L45.996,47.751" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.623,46.401 L48.973,47.751" />
    <path strokeWidth={1.5} d="M47.623,46.401 L48.973,47.751" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M47.623,46.123 L48.973,44.773" />
    <path strokeWidth={1.5} d="M47.623,46.123 L48.973,44.773" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.271,46.123 L68.921,44.773" />
    <path strokeWidth={1.5} d="M70.271,46.123 L68.921,44.773" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.271,46.401 L68.921,47.751" />
    <path strokeWidth={1.5} d="M70.271,46.401 L68.921,47.751" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.549,46.401 L71.899,47.751" />
    <path strokeWidth={1.5} d="M70.549,46.401 L71.899,47.751" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M70.549,46.123 L71.899,44.773" />
    <path strokeWidth={1.5} d="M70.549,46.123 L71.899,44.773" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.42,72.647 L23.07,71.297" />
    <path strokeWidth={1.5} d="M24.42,72.647 L23.07,71.297" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.42,72.925 L23.07,74.275" />
    <path strokeWidth={1.5} d="M24.42,72.925 L23.07,74.275" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.697,72.925 L26.047,74.275" />
    <path strokeWidth={1.5} d="M24.697,72.925 L26.047,74.275" />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M24.697,72.647 L26.047,71.297" />
    <path strokeWidth={1.5} d="M24.697,72.647 L26.047,71.297" />
    <path
      strokeWidth={3}
      d="M15.981,1.5 L78.989,1.5 C83.755,1.5 87.619,5.364 87.619,10.131 L87.619,82.393 C87.619,87.16 83.755,91.024 78.989,91.024 L15.981,91.024 C11.214,91.024 7.35,87.16 7.35,82.393 L7.35,10.131 C7.35,5.364 11.214,1.5 15.981,1.5 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#505FB4"
      d="M101.888,45.628 C100.354,45.628 98.991,46.054 97.788,46.831 C97.939,46.093 98.023,45.341 98.023,44.576 C98.023,35.281 86.578,27.745 72.46,27.745 C58.341,27.745 46.896,35.281 46.896,44.576 C46.896,45.34 46.977,46.091 47.127,46.828 C45.924,46.053 44.563,45.628 43.031,45.628 C35.011,45.628 36.32,53.812 36.32,53.812 C36.763,57.707 41.261,65.651 41.671,83.629 C41.695,84.667 42.54,85.498 43.578,85.498 L72.46,85.498 L101.341,85.498 C102.379,85.498 103.224,84.667 103.248,83.629 C103.658,65.651 108.156,57.707 108.599,53.812 C108.599,53.812 109.908,45.628 101.888,45.628"
    />
    <path
      strokeWidth={3}
      d="M72.459,85.698 L43.578,85.698 C42.54,85.498 41.696,84.667 41.672,83.629 C41.261,65.651 36.763,57.707 36.321,53.812 C36.321,53.812 35.011,45.628 43.031,45.628 C51.052,45.628 54.431,57.206 54.431,70.301 L54.431,75.31 L72.459,75.31"
    />
    <path strokeWidth={1.5} d="M54.431,75.311 L54.431,85.499" />
    <path strokeWidth={3} d="M72.459,27.749 C72.459,27.749 46.895,27.041 46.895,45.988" />
    <path
      strokeWidth={3}
      d="M72.459,85.698 L101.341,85.698 C102.379,85.498 103.224,84.667 103.248,83.629 C103.659,65.651 108.156,57.707 108.599,53.812 C108.599,53.812 109.909,45.628 101.888,45.628 C93.868,45.628 90.487,57.206 90.487,70.301 L90.487,75.31 L72.459,75.31"
    />
    <path
      strokeWidth={1.5}
      d="M90.488,63.278 C89.734,61.633 86.632,61.708 86.632,61.708 L58.288,61.708 C58.288,61.708 55.185,61.633 54.432,63.278"
    />
    <path strokeWidth={1.5} d="M90.488,75.311 L90.488,85.499" />
    <path strokeWidth={3} d="M72.459,27.749 C72.459,27.749 98.023,27.041 98.023,45.988" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      points="47.289 91.376 51.967 91.376 52.967 85.698 46.289 85.698"
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      points="93.001 91.376 97.679 91.376 98.679 85.698 92.001 85.698"
    />
    <polygon strokeWidth={3} points="47.289 91.376 51.967 91.376 52.967 85.698 46.289 85.698" />
    <polygon strokeWidth={3} points="93.001 91.376 97.679 91.376 98.679 85.698 92.001 85.698" />
    <polygon stroke="none" strokeWidth={1} fill="#E7EBF6" points="20 90 68 90 68 58 20 58" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#3A427C"
      d="M66.75,71 L21.25,71 C20.559,71 20,70.328 20,69.499 C20,68.672 20.559,68 21.25,68 L66.75,68 C67.441,68 68,68.672 68,69.499 C68,70.328 67.441,71 66.75,71"
      opacity={0.2}
    />
    <polygon strokeWidth={3} points="21.5 91.5 66.5 91.5 66.5 67.5 21.5 67.5" />
    <polygon strokeWidth={3} points="19.5 67.5 69.5 67.5 69.5 59.5 19.5 59.5" />
  </svg>
);

export default Furniture;



// WEBPACK FOOTER //
// ./src/assets/images/icons/furniture.js